export const TITLE_FONT = "font-starjedi";
export const CONTENT_FONT = "font-exo2";
export const AUREBESH_FONT = "font-aurebesh";
export const FONT_NAME_PART_TO_REMOVE = 'font-';

export const NUMBER_DAILY_QUESTIONS = 4;
export const NUMBER_DAILY_CHARACTERS = 2;
export const RIGHT_ANSWER_CHAR = '✅';
export const WRONG_ANSWER_CHAR = '❌';
export const NO_ANSWER_CHAR = ' ';

export const SEPARATOR_IN_FILES = '|||';

export const HOME_BACKGROUND_CLASS = "home-background";
export const INFO_BACKGROUND_CLASS = "info-background";

export const HOW_TO_IMAGE_QUESTIONS = ['question_img1.png', 'question_img2.png'];
export const HOW_TO_IMAGE_IDENTITY = ['identity_img1.png', 'identity_img2.png', 'identity_img3.png'];
export const HOW_TO_IMAGE_DAILY = ['daily_img1.png', 'daily_img2.png', 'daily_img3.png'];
export const FLAG_FILES = ['empire.png', 'rebels.png', 'chiss_ascendancy.svg',
    'jedi.svg', 'nihil.svg', 'republic.png', 'starbird.png'];

export const WORDS_TO_REMOVE = ['a', 'an', 'some', 'the', 'on', 'sur', 'le', 'la', 'un', 'une', 'les', 'des', "it's", "c'est",
    "c'était", 'it', 'was', 'for', 'pour'];